import { render } from "./PhDotsThreeBold.vue?vue&type=template&id=7a4127ac"
import script from "./PhDotsThreeBold.vue?vue&type=script&lang=js"
export * from "./PhDotsThreeBold.vue?vue&type=script&lang=js"
script.render = render

export default script